<template>
  <button
    class="suggestion-button"
    @click="$emit('select', data)"
  >
    <span class="suggestion-icon-wrap">
      <v-icon size="16">
        mdi-creation
      </v-icon>
    </span>

    <span class="suggestion-text">
      {{ suggestionText }}
    </span>
  </button>
</template>

<script>
export default {
  name: 'MessageSuggestion',

  props: {
    data: {
      type    : Object,
      required: true
    }
  },

  computed: {
    suggestionText () {
      return this.data.displayContent || this.data.content || ''
    }
  }
}
</script>

<style scoped>
.suggestion-button {
  position: relative;

  display: flex;
  align-items: stretch;
  gap: 0;

  width: 100%;
  min-height: 58px;
  padding: 0;

  border: 2px solid rgba(255, 255, 255, 0.98);
  border-radius: 8px;
  background: radial-gradient(39.15% 72.31% at 50.12% 27.69%, rgba(255, 255, 255, 0.64) 0%, rgba(255, 255, 255, 0) 100%);
  color: #041f30;

  cursor: pointer;
  text-align: left;
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;

  box-shadow:
    0 16px 16px -16px #3D68D529,
    0 1px 6px -4px #3D68D5;

  overflow: hidden;

  transition:
    border-color 0.15s ease,
    transform 0.15s ease,
    box-shadow 0.15s ease;

  animation: suggestionAppear 0.5s cubic-bezier(0.16, 1, 0.3, 1) both;
}

.suggestion-button::after {
  content: '';

  position: absolute;
  top: 0;
  left: -60%;

  width: 45%;
  height: 100%;

  background: linear-gradient(
    115deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.75) 50%,
    rgba(255, 255, 255, 0) 100%
  );

  pointer-events: none;

  animation: suggestionShine 1.1s ease 0.15s 1;
}

.suggestion-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 32px;
  align-self: stretch;
  width: 32px;
  border-radius: 6px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  background: linear-gradient(180deg, #dfe9fb 0%, #c9d9f4 100%);
}

.suggestion-text {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  padding: 0 14px;
  overflow-wrap: anywhere;
}

.suggestion-button:hover {
  border-color: #93de94;
  box-shadow:
    inset 0 0 0 1px rgba(255, 255, 255, 0.5),
    0 5px 14px rgba(21, 43, 74, 0.08);
}

.suggestion-button:active {
  transform: translateY(1px);
}

.suggestion-button:focus {
  outline: none;
  border-color: #ffffff;
}

@keyframes suggestionAppear {
  from {
    opacity: 0;
    filter: blur(3px);
    transform: translateY(10px) scale(0.96);
  }
  to {
    opacity: 1;
    filter: blur(0);
    transform: translateY(0) scale(1);
  }
}

@keyframes suggestionShine {
  from {
    left: -60%;
  }
  to {
    left: 130%;
  }
}
</style>
